<template>
  <znl-dialog
    :visible="visible"
    :append-to-body="true"
    title="常见问题"
    width="600px"
    class="c-CommonProblems"
    @close="$emit('update:visible', false)"
  >
    <div>
      <h4>
        问题一：为什么【库存推广】的库存在【库存定价】中找不到？
      </h4>
      <p>
        为保证库存品质与时效性，满足以下条件的库存方可同步到【库存定价】中。
      </p>
      <p>
        1、类型为“正品企业”和“正品物料“。
        <br />
        2、仓库位置必须包含“深圳”。
        <br />
        3、库存状态必须是“展示中”。
      </p>
      <h4>
        问题二：删除库存后重新上传，定价需要重新设定吗？
      </h4>
      <p>
        不需要，库存删除后系统仍会保留定价。重新上传系统将通过“型号、品牌、封装、批号”区分库存并重新匹配定价。
      </p>
      <h4>
        问题三：什么是MPQ，结算价？
      </h4>
      <p>
        MPQ：Minimum Package Quantity，最小包装数。
      </p>
      <p>
        结算价：与正能量结算的价格。
      </p>

    </div>
    <div slot="footer">
      <znl-button
        :width="80"
        :height="30"
        @click="showQQ"
      >联系客服</znl-button>
      <znl-button
        :width="80"
        :height="30"
        style-type="main"
        class="fml"
        @click="$emit('update:visible', false)"
      >好的</znl-button>
    </div>
  </znl-dialog>
</template>
<script>
export default {
  props: {
    visible: Boolean
  },
  methods: {
    showQQ() {
      window.open(
        'http://wpa.qq.com/msgrd?v=3&uin=800106568&site=qq&menu=yes',
        '_brank'
      );
    }
  }
};
</script>
<style lang="scss">
.c-CommonProblems {
  .fml {
    margin-left: 10px;
  }
  h4 {
    margin: 5px 0;
  }
  p {
    font-size: 12px;
  }
}
</style>


